<template>
  <div class="table-wrapper">
    <el-table ref="elTab" :data="tableData" header-cell-class-name="grey-background" style="width: 100%" @selection-change="handleSelectionChange" @select='tableSelectChange' @sort-change="sortChange" :key="config.tabKey" @select-all='tableSelectAllChange' border v-loading="config.loading">
      <div v-if="config.isShow">
        <div v-for="(tItem, tIndex) in config.tableHeaders" :key="tIndex">
          <el-table-column v-if="tItem.type === 'selection'" type="selection" fixed width="50" align="center"></el-table-column>
          <el-table-column v-else-if="tItem.type === 'index'" :type="tItem.type" fixed width="60px" label="编号" :index="indexMethod" tooltip-effect="light" align="center"></el-table-column>
          <!-- <el-table-column :type="tItem.type" v-else-if="tItem.type === 'expand'" fixed = 'left'>
            <template slot-scope="props">
              <el-form label-position="left" inline  class="table-expand">
                <div v-for="(item, index) in config.tableHeaders" :key="index">
                  <el-form-item :label="item.label" v-if="!item.isNo">
                    <span v-if="item.formatter">{{item.formatter(props.row[item.prop])}}</span>
                    <span v-else>{{props.row[item.prop]}}</span>
                  </el-form-item>
                </div>
              </el-form>
            </template>
          </el-table-column>-->
          <el-table-column :fixed="tItem.fixed" :formatter="tItem.formatter" :sortable="tItem.sortable" :prop="tItem.prop" :label="tItem.label" v-else-if="tItem.isShow" :width="tItem.width" :min-width="tItem.minWidth" :show-overflow-tooltip="tItem.overflowHide" :align="tItem.align ? tItem.align : 'center'">
            <template slot-scope="scope">
              <slot v-if="tItem.template" :name="tItem.template" :index="scope.$index" :rowData="scope.row"></slot>
              <div v-else>
                <span v-if="tItem.formatter" v-html="tItem.formatter(scope.row[tItem.prop],scope.row,scope.$index)"></span>
                <span v-else>{{scope.row[tItem.prop]}}</span>
              </div>
            </template>
          </el-table-column>
        </div>
      </div>
      <div v-else>
        <el-table-column v-for="(aItem, aIndex) in config.tableHeaders" :key="aIndex" :label="aItem.label"  :align="tItem.align ? tItem.align : 'center'" :prop="aItem.prop" :fixed="aItem.fixed">
          <div v-if='aItem.children && aItem.children.length > 0'>
            <el-table-column v-for="(BItem, BIndex) in aItem.children" :key="BIndex" :fixed="BItem.fixed" :formatter="BItem.formatter" :sortable="BItem.sortable" :prop="BItem.prop" :label="BItem.label" :width="BItem.width" :min-width="BItem.minWidth" :show-overflow-tooltip="BItem.overflowHide" :align="tItem.align ? tItem.align : 'center'">
            </el-table-column>
          </div>
        </el-table-column>
      </div>
    </el-table>
    <el-dialog title="图片预览" :visible.sync="fileData.dialogVisible" width="600px">
      <img width="100%" v-if="fileData.type === 'image'" :src="fileData.url" alt>
      <audio v-else-if="fileData.type === 'audio'" controls :src="fileData.url"></audio>
      <video v-else-if="fileData.type === 'video'" controls :src="fileData.url"></video>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    config: {
      type: Object,
      default() {
        return {};
      }
    },
    page: {
      type: Number,
      default() {
        return 1;
      }
    },
    limit: {
      type: Number,
      default() {
        return 10;
      }
    },
    tableData: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      fileData: {
        type: "",
        url: "",
        dialogVisible: false
      }
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$emit("getData");
    },
    handleSelectionChange(data) {
      var selectList = [];
      for (var i = 0; i < data.length; i++) {
        selectList.push(data[i].id);
      }
      this.$emit("handleSelection", selectList);
    },
    tableSelectChange(data) {
      var selectList = [];
      for (var i = 0; i < data.length; i++) {
        selectList.push(data[i].id);
      }
      this.$emit("tableSelect", selectList);
    },
    tableSelectAllChange(data) {
      var selectList = [];
      for (var i = 0; i < data.length; i++) {
        selectList.push(data[i].id);
      }
      this.$emit("tableSelectAll", selectList);
    },
    sortChange(data) {
      this.$emit("sortChange", data);
    },
    previewImg(type, url) {
      this.fileData.type = type;
      this.fileData.url = url;
      this.fileData.dialogVisible = true;
    },
    indexMethod(index) {
      var that = this;
      return (that.page - 1) * that.limit + index + 1;
    }
  },
  components: {}
};
</script>
<style scoped>
.table-img {
  width: 80px;
  height: 80px;
  margin: 0 auto;
  position: relative;
}

.table-expand {
  font-size: 0;
}

.table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  display: flex;
  width: 100%;
}
</style>
<style>
.table-wrapper .grey-background {
  background: #f6f8fa;
  color: #353535;
}

.table-expand label {
  width: 90px;
  color: #99a9bf;
}

.table-expand .el-form-item__content {
  flex: 1;
  text-align: justify;
  word-break: break-all;
}
.el-table .cell.el-tooltip span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  word-wrap: break-word;
  display: block;
}
</style>
